export enum LayoutNodeTypes {
  Row = 'row',
  Column = 'column',
  Stack = 'stack',
  Component = 'component',
}
